module.exports = __webpack_public_path__ + "img/athletics_icon_4.8f784741.png";